import { usePreviousRoute } from '~/stores/previous-route'

export default defineNuxtRouteMiddleware((_, from) => {
  const { setPreviousRoute } = usePreviousRoute()
  setPreviousRoute(from.path)
})
